import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderBrandPage = lazy(() => import('../views/list/ProviderBrandPage'));

export function ProviderBrandPageLazy() {
	return (
		<PageSuspense>
			<ProviderBrandPage />
		</PageSuspense>
	);
}
